(function () {
    "use strict";

    angular
        .module("Agnes")

        .controller("ReportsController", [
            "$scope", "$sessionStorage", "$user", "$locale", "moment",
            function ($scope, $sessionStorage, user, locale, moment) {
                $scope.user = user;
                $scope.$storage = $sessionStorage;

                $scope.getStartOfMonth = function () {
                    return moment().locale(__AGNES__.lang.current).startOf('month').format("L");
                };

                $scope.getEndOfMonth = function () {
                    return moment().locale(__AGNES__.lang.current).endOf('month').format("L");
                };

                $scope.getTabName = function () {
                    return 'AgnesReport' + Date.now();
                };
            }
        ]);
})();